import { TabModules } from '~/data/company';
import { EmployeeModuleConfig } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/types';

export enum EmployeeModuleTabPath_Performance {
  GoalSetting = 'goal-setting',
  GoalEvaluation = 'goal-evaluation',
  SelfEvaluation = 'self-evaluation',
  Feedback = 'feedback',
  PerformanceEvaluation = 'performance-evaluation',
  Notes = 'notes',
  StatusDiscussion = 'status-discussion',
  AppraisalEvaluation = 'appraisal-evaluation',
}

export enum EmployeeModuleTabConfigKey_Performance {
  AppraisalEvaluation = 'PERF_APPRAISAL',
  Feedback = 'PERF_FEEDBACK',
  GoalEvaluation = 'PERF_GOAL_EVALUATION',
  GoalSetting = 'PERF_GOAL_SETTING_REVIEW',
  Notes = 'PERF_NOTES',
  PerformanceEvaluation = 'PERF_PERF_EVAL',
  ProcessTemplates = 'PERF_PROCESS_TEMPLATES',
  SelfEvaluation = 'PERF_SELF_EVAL',
  StatusDiscussion = 'PERF_STATUS_DISC',
}

export enum EmployeeModuleTabInstructionKey_Performance {
  AppraisalEvaluation = 'INSTRUCTIONS_PERF_APPRAISAL_EVALUATION',
  Feedback = 'INSTRUCTIONS_PERF_FEEDBACK',
  GoalEvaluation = 'INSTRUCTIONS_PERF_GOAL_EVALUATION',
  GoalSetting = 'Instructions_Goal_setting',
  Notes = 'INSTRUCTIONS_PERF_NOTES_HEADER',
  PerformanceEvaluation = 'INSTRUCTIONS_PERF_PERFORMANCE_EVALUATION_HEADER',
  ProcessTemplates = 'APPRAISAL_EVALUATION',
  SelfEvaluation = 'INSTRUCTIONS_PERF_SELF_EVALUATION_HEADER',
  StatusDiscussion = 'INSTRUCTIONS_PERF_STATUS_DISCUSSION_HEADER',
}

export const EmployeeModuleRouting_Performance: EmployeeModuleConfig<
  EmployeeModuleTabPath_Performance,
  EmployeeModuleTabConfigKey_Performance,
  EmployeeModuleTabInstructionKey_Performance
> = {
  path: 'performance',
  module: TabModules.PERFORMANCE,
  defaultTab: EmployeeModuleTabPath_Performance.GoalSetting,
  tabConfigs: [
    {
      path: EmployeeModuleTabPath_Performance.GoalSetting,
      enabledConfigKey: EmployeeModuleTabConfigKey_Performance.GoalSetting,
      instructionKey: EmployeeModuleTabInstructionKey_Performance.GoalSetting,
    },
    {
      path: EmployeeModuleTabPath_Performance.GoalEvaluation,
      enabledConfigKey: EmployeeModuleTabConfigKey_Performance.GoalEvaluation,
      instructionKey:
        EmployeeModuleTabInstructionKey_Performance.GoalEvaluation,
    },
    {
      path: EmployeeModuleTabPath_Performance.SelfEvaluation,
      enabledConfigKey: EmployeeModuleTabConfigKey_Performance.SelfEvaluation,
      instructionKey:
        EmployeeModuleTabInstructionKey_Performance.SelfEvaluation,
    },
    {
      path: EmployeeModuleTabPath_Performance.Feedback,
      enabledConfigKey: EmployeeModuleTabConfigKey_Performance.Feedback,
      instructionKey: EmployeeModuleTabInstructionKey_Performance.Feedback,
    },
    {
      path: EmployeeModuleTabPath_Performance.PerformanceEvaluation,
      enabledConfigKey:
        EmployeeModuleTabConfigKey_Performance.PerformanceEvaluation,
      instructionKey:
        EmployeeModuleTabInstructionKey_Performance.PerformanceEvaluation,
    },
    {
      path: EmployeeModuleTabPath_Performance.Notes,
      enabledConfigKey: EmployeeModuleTabConfigKey_Performance.Notes,
      instructionKey: EmployeeModuleTabInstructionKey_Performance.Notes,
    },
    {
      path: EmployeeModuleTabPath_Performance.StatusDiscussion,
      enabledConfigKey: EmployeeModuleTabConfigKey_Performance.StatusDiscussion,
      instructionKey:
        EmployeeModuleTabInstructionKey_Performance.StatusDiscussion,
    },
    {
      path: EmployeeModuleTabPath_Performance.AppraisalEvaluation,
      enabledConfigKey:
        EmployeeModuleTabConfigKey_Performance.AppraisalEvaluation,
      instructionKey:
        EmployeeModuleTabInstructionKey_Performance.AppraisalEvaluation,
    },
  ],
};
